import { AwsRum, AwsRumConfig } from "aws-rum-web";

try {
  const config: AwsRumConfig = {
    enableRumClient: window.location.hostname === "control.edrone.me",
    sessionSampleRate: 1,
    identityPoolId: "eu-west-1:9741da51-8f9a-4691-bdf1-3f5e8e529488",
    endpoint: "https://dataplane.rum.eu-west-1.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false,
  };

  const APPLICATION_ID: string = "0b90a504-4e8b-48ef-8513-738a18bda037";
  const APPLICATION_VERSION: string = "1.0.0";
  const APPLICATION_REGION: string = "eu-west-1";

  new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}
